import { securityHighlights } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function Security() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="安全与可信"
          title="以可信技术，守护每一次权益发放"
          subtitle="围绕账户、交易、数据及运营权限建立全流程保障机制，让每一笔资金流向清晰、每一次活动可核验。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {securityHighlights.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 text-xs md:text-sm text-foreground-500 leading-relaxed max-w-3xl">
          注：真实资质、合作银行、合规认证或技术架构，将在获得确认后于本区块展示，未确认前不使用绝对化安全承诺。
        </p>
      </div>
    </section>
  );
}